/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getActiveProfileSubscription } from '../fn/profile-subscription/get-active-profile-subscription';
import { GetActiveProfileSubscription$Params } from '../fn/profile-subscription/get-active-profile-subscription';
import { ProfileSubscription } from '../models/profile-subscription';

@Injectable({ providedIn: 'root' })
export class ProfileSubscriptionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getActiveProfileSubscription()` */
  static readonly GetActiveProfileSubscriptionPath = '/rest/profile/{id}/subscription';

  /**
   * Get active profile subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveProfileSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveProfileSubscription$Response(params: GetActiveProfileSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileSubscription>> {
    return getActiveProfileSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Get active profile subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActiveProfileSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveProfileSubscription(params: GetActiveProfileSubscription$Params, context?: HttpContext): Observable<ProfileSubscription> {
    return this.getActiveProfileSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileSubscription>): ProfileSubscription => r.body)
    );
  }

}
